// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.mapslider-range-slider {
  position: absolute;
  z-index: 101;
  bottom: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  right: 38%;
  color: white; }
  .mapslider-range-slider strong {
    margin-left: 6px;
    border: 1px solid white;
    padding: 2px 4px;
    border-radius: 4px; }
  .mapslider-range-slider .form-range {
    width: 25%; }
  .mapslider-range-slider .wrapper {
    width: 550px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #021d3e;
    padding: 0.75rem;
    border-radius: 4px;
    border: 1px solid gray;
    position: relative;
    flex-direction: column; }
    .mapslider-range-slider .wrapper p {
      cursor: auto; }
    .mapslider-range-slider .wrapper .range-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center; }
    .mapslider-range-slider .wrapper input {
      width: 80%; }
    .mapslider-range-slider .wrapper .wrap-fillwidth input {
      width: 18px !important; }
    .mapslider-range-slider .wrapper .mapslider-slider-button-active {
      color: #257ee0;
      background-color: white; }
    .mapslider-range-slider .wrapper .mapslider-help-button {
      position: absolute;
      right: 8px; }
    .mapslider-range-slider .wrapper .mapslider-color-span {
      position: absolute;
      top: 22px;
      right: 0px; }
    .mapslider-range-slider .wrapper .close-wrapper {
      position: absolute;
      right: 1%;
      top: 5%;
      width: 25px;
      height: 25px;
      display: flex;
      justify-content: center;
      align-items: center; }
      .mapslider-range-slider .wrapper .close-wrapper svg {
        height: 20px;
        cursor: pointer; }

.mapslider-categories-popover {
  color: #fff;
  background-color: #12234f;
  min-width: 500px;
  font-size: 1em;
  margin: 10px;
  max-width: 800px;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2); }
  .mapslider-categories-popover .mapslider-categories-popover-body {
    color: white !important;
    min-width: 500px;
    font-size: 1.2em;
    margin: 10px; }
  .mapslider-categories-popover .popover-header {
    background-color: #12234f;
    color: white !important;
    font-size: 1.2em; }

.mapslider-range-slider-eddi {
  position: absolute;
  z-index: 101;
  bottom: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  overflow: hidden;
  color: white;
  margin-left: 15%; }
  .mapslider-range-slider-eddi strong {
    margin-left: 6px;
    border: 1px solid white;
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 2vh;
    text-wrap: nowrap;
    text-shadow: 1px 2px black;
    background-color: #021d3e;
    min-width: 15vw; }
  .mapslider-range-slider-eddi .form-range {
    width: 80% !important;
    text-shadow: 1px 2px black;
    border: 1px solid black;
    border-radius: 5px;
    height: min-content;
    background-color: #021d3e; }

.range-select {
  background-color: #0b1735;
  border-radius: 8px;
  padding: 1rem; }
  .range-select h6 {
    text-align: center; }
  .range-select select {
    width: 100px; }

.mapslider-popover-body {
  color: white !important;
  min-width: 500px;
  font-size: 1em;
  margin: 10px; }

.FHO {
  position: absolute;
  z-index: 101;
  bottom: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  right: unset;
  left: 14px !important;
  color: white; }
  .FHO .close-wrapper {
    top: 65px !important;
    right: 18px !important; }
  .FHO .legend-item-browse:hover {
    border: .1px solid #4fc2d9;
    cursor: pointer; }
  .FHO .te-map-legend-accordion-body {
    padding: 2px 2px 2px 2px; }

.te-accordion-slider {
  min-height: auto;
  position: absolute;
  border-radius: 5px;
  padding: 5px;
  bottom: 32px;
  z-index: 2; }
  .te-accordion-slider .accordion-header button {
    background-color: #0b1736 !important;
    color: white !important; }

.nwshazard .nws-legend-spinner-parent {
  min-width: 23px;
  align-self: center;
  position: absolute;
  top: 40px;
  display: flex;
  flex-direction: row;
  font-size: 24px;
  background-color: #002044;
  width: 250px;
  justify-content: center;
  height: 55px;
  align-items: center; }

.nwshazard .nws-legend-swatch {
  display: flex;
  flex-direction: column;
  max-height: 200px;
  flex-wrap: wrap;
  overflow-y: scroll;
  max-width: 500px;
  overflow: scroll; }

.nwshazard .nwscolor {
  width: 20px;
  max-width: 40px;
  margin-right: 5px; }

.nwshazard .close-wrapper {
  top: 10px !important;
  right: 10px !important; }

.nwshazard .legend-item {
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  max-width: 190px;
  font-size: 1em; }
  .nwshazard .legend-item a {
    color: white; }
  .nwshazard .legend-item a:hover {
    color: #0d6efd; }

.cvi {
  width: 22rem; }
  .cvi select {
    width: 100% !important; }

.wrfc {
  position: relative; }
  .wrfc .close-wrapper {
    right: 3%;
    top: 3%;
    position: absolute;
    cursor: pointer; }
  .wrfc select {
    width: 250px; }
  .wrfc p {
    text-align: center;
    margin-bottom: 8px;
    font-weight: bold; }

.radio-menu {
  width: 32rem;
  margin: 1rem;
  background: #0b1735;
  padding: 6px;
  border-radius: 4px; }
  .radio-menu input {
    cursor: pointer; }
  .radio-menu svg {
    margin-left: 5%;
    margin-bottom: 3%; }

.slider-input {
  width: 75% !important; }

.ys,
.epo {
  width: 530px;
  position: relative; }
  .ys p,
  .epo p {
    text-align: center;
    margin-bottom: 8px; }
  .ys .close-wrapper,
  .epo .close-wrapper {
    right: 3%;
    position: absolute;
    top: 3%;
    cursor: pointer; }

.close-box {
  position: absolute;
  top: 8%;
  left: 63%; }
  .close-box svg {
    cursor: pointer; }

.x {
  margin: 0;
  margin-left: 1%;
  margin-bottom: 3%; }

.form-check-rainfall {
  width: 14rem;
  background: #021d3e;
  padding: 1rem;
  border-radius: 4px;
  border: 1px solid gray; }

#waterConflict,
#impairedLakes {
  position: absolute;
  bottom: 15%;
  left: 30%;
  width: 40rem; }

.impairedLakes {
  z-index: 100 !important; }

.water-conflict {
  background: #0b1735;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex-direction: column; }

#USGSWUC,
#USGSHuc12 {
  position: absolute;
  bottom: 10%;
  right: 40%; }
  #USGSWUC .range-wrapper,
  #USGSHuc12 .range-wrapper {
    width: 35rem; }
  #USGSWUC .form-range.USGSWUC,
  #USGSHuc12 .form-range.USGSWUC {
    width: 75% !important; }
  #USGSWUC strong, #USGSWUC .range-wrapper,
  #USGSHuc12 strong,
  #USGSHuc12 .range-wrapper {
    display: flex;
    align-items: center; }
  #USGSWUC strong,
  #USGSHuc12 strong {
    width: 140px; }
  #USGSWUC p,
  #USGSHuc12 p {
    text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/shared/MapSlider.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACrBrD;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,YAAY,EAAA;EATd;IAWI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB,EAAA;EAdtB;IAiBI,UAAU,EAAA;EAjBd;IAqBI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB,EAAA;IAjC1B;MAmCM,YAAY,EAAA;IAnClB;MAsCM,WAAW;MACX,aAAa;MACb,uBAAuB;MACvB,mBAAmB,EAAA;IAzCzB;MA4CM,UAAU,EAAA;IA5ChB;MAiDQ,sBAAsB,EAAA;IAjD9B;MAsDK,cAAc;MACd,uBAAuB,EAAA;IAvD5B;MA2DK,kBAAiB;MACjB,UAAU,EAAA;IA5Df;MAgEQ,kBAAkB;MACrB,SAAS;MACT,UAAU,EAAA;IAlEf;MAsEM,kBAAkB;MAClB,SAAS;MACT,OAAO;MACP,WAAW;MACX,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB,EAAA;MA7EzB;QA+EQ,YAAY;QACZ,eAAe,EAAA;;AAOvB;EACI,WD1FmB;EC2FnB,yBAAyB;EAGzB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,wCAAwC,EAAA;EAT5C;IAYQ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY,EAAA;EAfpB;IAmBK,yBAAyB;IACtB,uBAAuB;IACvB,gBAAgB,EAAA;;AAKxB;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB,EAAA;EAVlB;IAaI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe,EAAA;EArBnB;IAyBI,qBAAqB;IACrB,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB,EAAA;;AAI7B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa,EAAA;EAHf;IAKI,kBAAkB,EAAA;EALtB;IAQI,YAAY,EAAA;;AAIhB;EACM,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,YAAY,EAAA;;AAGlB;EAYI,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,YAAY,EAAA;EArBhB;IAEM,oBAAoB;IACpB,sBAAsB,EAAA;EAH5B;IAOI,0BAA0B;IAC1B,eAAe,EAAA;EARnB;IAwBI,wBAAwB,EAAA;;AAI5B;EACI,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU,EAAA;EANd;IAUU,oCAAmC;IACnC,uBAAuB,EAAA;;AAMjC;EAEI,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,mBAAmB,EAAA;;AAbvB;EAiBI,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAA;;AAvBpB;EA2BM,WAAW;EACX,eAAe;EACf,iBAAiB,EAAA;;AA7BvB;EAiCM,oBAAoB;EACpB,sBAAsB,EAAA;;AAlC5B;EAsCI,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAA;EA1ClB;IA6CM,YAAY,EAAA;EA7ClB;IAiDM,cAAc,EAAA;;AAKpB;EACE,YAAY,EAAA;EADd;IAGI,sBAAsB,EAAA;;AAI1B;EACE,kBAAkB,EAAA;EADpB;IAGI,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,eAAe,EAAA;EANnB;IASI,YAAY,EAAA;EAThB;IAaI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB,EAAA;;AAIrB;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB,EAAA;EALpB;IAOI,eAAe,EAAA;EAPnB;IAUI,eAAe;IACf,iBAAiB,EAAA;;AAIrB;EACE,qBAAqB,EAAA;;AAGvB;;EAEE,YAAY;EACZ,kBAAkB,EAAA;EAHpB;;IAKI,kBAAkB;IAClB,kBAAkB,EAAA;EANtB;;IASI,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,eAAe,EAAA;;AAInB;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS,EAAA;EAHX;IAKI,eAAe,EAAA;;AAInB;EACE,SAAS;EACT,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB,EAAA;;AAGxB;;EAEE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY,EAAA;;AAGd;EACE,uBAAuB,EAAA;;AAGzB;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,sBAAsB,EAAA;;AAGxB;;EAEE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;EAJZ;;IAMI,YAAY,EAAA;EANhB;;IAUI,qBAAqB,EAAA;EAVzB;;;IAcI,aAAa;IACb,mBAAmB,EAAA;EAfvB;;IAkBW,YAAY,EAAA;EAlBvB;;IAqBI,kBAAkB,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n.mapslider-range-slider {\n  position: absolute;\n  z-index: 101;\n  bottom: 10%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  right: 38%;\n  color: white;\n  strong {\n    margin-left: 6px;\n    border: 1px solid white;\n    padding: 2px 4px;\n    border-radius: 4px;\n  }\n  .form-range {\n    width: 25%;\n  }\n\n  .wrapper {\n    width: 550px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #021d3e;\n    padding: 0.75rem;\n    border-radius: 4px;\n    border: 1px solid gray;\n    position: relative;\n    flex-direction: column;\n    p {\n      cursor: auto;\n    }\n    .range-wrapper {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    input {\n      width: 80%;\n    }\n\n    .wrap-fillwidth {\n      input {\n        width: 18px !important;\n      }   \n    }\n\n    .mapslider-slider-button-active {\n\t    color: #257ee0;\n\t    background-color: white;\n    }\n\n    .mapslider-help-button {\n    \tposition:absolute;\n    \tright: 8px;\n    }\n\n    .mapslider-color-span {\n        position: absolute;\n    \ttop: 22px;\n    \tright: 0px;\n    }\n\n    .close-wrapper {\n      position: absolute;\n      right: 1%;\n      top: 5%;\n      width: 25px;\n      height: 25px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      svg {\n        height: 20px;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n\n.mapslider-categories-popover {\n    color: $primaryFontColor;\n    background-color: #12234f;   \n\n  \n    min-width: 500px;\n    font-size: 1em;\n    margin: 10px;\n    max-width: 800px;\n    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);\n\n    .mapslider-categories-popover-body {\n        color: white !important;\n        min-width: 500px;\n        font-size: 1.2em;\n        margin: 10px;\n    }\n\n    .popover-header {\n    \tbackground-color: #12234f;\n        color: white !important;\n        font-size: 1.2em;\n    }\n}\n\n\n.mapslider-range-slider-eddi {\n  position: absolute;\n  z-index: 101;\n  bottom: 85px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50%;\n  overflow: hidden;\n  color: white;\n  margin-left: 15%;\n\n  strong {\n    margin-left: 6px;\n    border: 1px solid white;\n    padding: 2px 4px;\n    border-radius: 4px;\n    font-size: 2vh;\n    text-wrap: nowrap;\n    text-shadow: 1px 2px black;\n    background-color: #021d3e;\n    min-width: 15vw;\n  }\n\n  .form-range {\n    width: 80% !important;\n    text-shadow: 1px 2px black;\n    border: 1px solid black;\n    border-radius: 5px;\n    height: min-content;\n    background-color: #021d3e;\n  }\n}\n\n.range-select {\n  background-color: #0b1735;\n  border-radius: 8px;\n  padding: 1rem;\n  h6 {\n    text-align: center;\n  }\n  select {\n    width: 100px;\n  }\n}\n\n.mapslider-popover-body {\n      color: white !important;\n      min-width: 500px;\n      font-size: 1em;\n      margin: 10px;\n}\n\n.FHO {\n  .close-wrapper {\n      top: 65px !important;\n      right: 18px !important;\n  }\n\n  .legend-item-browse:hover {\n    border: .1px solid #4fc2d9;\n    cursor: pointer;\n  }\n\n\n    position: absolute;\n    z-index: 101;\n    bottom: 10%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    right: unset;\n    left: 14px !important;\n    color: white;\n\n  .te-map-legend-accordion-body {\n    padding: 2px 2px 2px 2px;\n  }\n}\n\n.te-accordion-slider {\n    min-height: auto;\n    position: absolute;\n    border-radius: 5px;\n    padding: 5px;\n    bottom: 32px;\n    z-index: 2;\n\n    .accordion-header {\n        button {\n          background-color: #0b1736!important;\n          color: white !important;        \n        }\n\n    }\n}\n\n.nwshazard {\n  .nws-legend-spinner-parent {\n    min-width: 23px;\n    align-self: center;\n    position: absolute;\n    top: 40px;\n    display: flex;\n    flex-direction: row;\n    font-size: 24px;\n    background-color: #002044;\n    width: 250px;\n    justify-content: center;\n    height: 55px;\n    align-items: center;\n  }\n\n  .nws-legend-swatch {\n    display: flex;\n    flex-direction: column;\n    max-height: 200px;\n    flex-wrap: wrap;\n    overflow-y: scroll;\n    max-width: 500px;\n    overflow: scroll;\n  }\n\n  .nwscolor {\n      width: 20px;\n      max-width: 40px;\n      margin-right: 5px;\n  }\n\n  .close-wrapper {\n      top: 10px !important;\n      right: 10px !important;\n  }\n\n  .legend-item {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 5px;\n    max-width: 190px;\n    font-size: 1em;\n\n    a {\n      color: white;\n    }\n\n    a:hover {\n      color: #0d6efd;\n    }\n  }\n}\n\n.cvi {\n  width: 22rem;\n  select {\n    width: 100% !important;\n  }\n}\n\n.wrfc {\n  position: relative;\n  .close-wrapper {\n    right: 3%;\n    top: 3%;\n    position: absolute;\n    cursor: pointer;\n  }\n  select {\n    width: 250px;\n  }\n\n  p {\n    text-align: center;\n    margin-bottom: 8px;\n    font-weight: bold;\n  }\n}\n\n.radio-menu {\n  width: 32rem;\n  margin: 1rem;\n  background: #0b1735;\n  padding: 6px;\n  border-radius: 4px;\n  input {\n    cursor: pointer;\n  }\n  svg {\n    margin-left: 5%;\n    margin-bottom: 3%;\n  }\n}\n\n.slider-input {\n  width: 75% !important;\n}\n\n.ys,\n.epo {\n  width: 530px;\n  position: relative;\n  p {\n    text-align: center;\n    margin-bottom: 8px;\n  }\n  .close-wrapper {\n    right: 3%;\n    position: absolute;\n    top: 3%;\n    cursor: pointer;\n  }\n}\n\n.close-box {\n  position: absolute;\n  top: 8%;\n  left: 63%;\n  svg {\n    cursor: pointer;\n  }\n}\n\n.x {\n  margin: 0;\n  margin-left: 1%;\n  margin-bottom: 3%;\n}\n\n.form-check-rainfall {\n  width: 14rem;\n  background: #021d3e;\n  padding: 1rem;\n  border-radius: 4px;\n  border: 1px solid gray;\n}\n\n#waterConflict, \n#impairedLakes {\n  position: absolute;\n  bottom: 15%;\n  left: 30%;\n  width: 40rem;\n}\n\n.impairedLakes {\n  z-index: 100 !important;\n}\n\n.water-conflict {\n  background: #0b1735;\n  padding: 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n#USGSWUC, \n#USGSHuc12 {\n  position: absolute;\n  bottom: 10%;\n  right: 40%;\n  .range-wrapper  {\n    width: 35rem;\n  }\n\n  .form-range.USGSWUC {\n    width: 75% !important;\n  }\n\n  strong, .range-wrapper {\n    display: flex;\n    align-items: center;\n  }\n\n  strong { width: 140px; }\n\n  p {\n    text-align: center;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
